export const es = {
  login: {
    TITLE: 'Iniciar Sesión',
    EMAIL: { TEXT: 'Correo', PLACEHOLDER: 'Correo electrónico' },
    PASSWORD: { TEXT: 'Contraseña', PLACEHOLDER: '**********' },
    RECOVER: { TEXT: 'Olvide mi contraseña' },
  },
  'password-recovery': {
    TITLE: 'Recuperar contraseña',
    RECOVER: 'Restablecer contraseña',
    SEND_MAIL:
      'Hemos enviado por correo electrónico el enlace para restablecer su contraseña!',
    SUCCESS: {
      SUMMARY: 'Correo enviado',
      DETAIL: 'Revisa tu correo y sigue las instrucciones',
      SUCCESS: 'Su contraseña fue cambiada con éxito',
    },
  },
  roles: {
    ADMIN: 'Administrador',
    MANUFACTURE: 'Manufactura',
  },
  strings: {
    LOGOUT_SUCCESS: 'Cerraste sesión con éxito',
    PROFILE: 'Perfil',
    HOME: 'Inicio',
    DASHBOARD: 'Dashboard',
    USERS: 'Usuarios',
    ARTICLES: 'Materiales',
    CATEGORIES: 'Categorias',
    TYPES: 'Tipos',
    METRICS: 'Unidades de medida',
    RM: 'Recepción de mercancia',
    PURCHASE_ORDERS: 'Órdenes de compra',
    INVENTORY: 'Inventario',
    HISTORY: 'Kardex',
    RECEPTION: 'Recepciones',
    SUPPLIERS: 'Proveedores',
    CUSTOMERS: 'Clientes',
    RELOCATION: 'Reubicaión',
    TRANSFERS: 'Traspasos',
    INVENTORY_MANAGEMENT: 'Gestión de Inventario',
    PURCHASE_MANAGEMENT: 'Gestión de OCs',
    WAREHOUSE_MANAGEMENT: 'Gestión de Almacenes',
    SUPPLIER_MANAGEMENT: 'Gestión de Proveedores',
    WELCOME_USER: 'Bienvenido {attribute}',
    CREDENTIALS: 'Por favor introduce tus credenciales',
    GENERAL_INFORMATION: 'Datos generales',
    TECHNICAL_DATA: 'Datos Técnicos',
    REPORT: 'reporte',
    DETAIL: 'detalle',
    DONE: 'Done',
    ADD_OC: 'Agregar OC',
    FEET: 'Pies',
    INCHES: 'Pulgadas',
    TAB: 'También puedes dar enter para agregar y tab para ir a siguiente input',
    ARE_YOU_SURE: {
      TITLE: '{attribute}',
      TEXT: '¿Estás seguro de continuar, esta acción no se podrá revertir?',
    },
    ARE_YOU_SURE_APPLIED: {
      TITLE: '{attribute}',
      TEXT: 'Al aplicar esta salida tendrá un costo unitario de {attribute}',
    },
    ARE_YOU_SURE_CANCELLED: {
      TITLE: '{attribute}',
      TEXT: 'Al cancelar la orden de compra {attribute} no afectara en ninguna operación/actividad que tenga relación con esta orden de compra',
    },
    MODAL: {
      ADD: 'Agregar {attribute}',
      EDIT: 'Editar {attribute}',
      APPLIED: 'Aplicar {attribute}',
      SHOW: 'Ver {attribute}',
      RECEIVE: 'Recibir traspaso {attribute}',
      PROFILE: 'Mi perfil',
    },
    SOMETHING_WENT_WRONG: 'Ups! algo salio mal',
    CRUD_HELPER: '{attribute} con éxito',
    SUBTITLE_SUMMARY: 'Un resumen de sus {attribute}',
    SEARCH: 'Búsqueda',
    ORDER_BY: 'Ordernar',
    NO_DATA_TO_DISPLAY: 'Sin datos para mostrar',
    LOCATIONS: 'Localidades',
    LOCATION_DESTINATION: 'Localidad destino',
    WAREHOUSE_DESTINATION: 'Almacén destino',
    WAREHOUSE: 'Almacén',
    MOVEMENT_REQUEST: 'Movimientos manuales',
    OUT: 'Salida',
    STOCK: 'Existencia',
    EXISTING_QUANTITY: 'Cantidad disponible',
    APPROXIMATE: 'Aproximado',
    TONS: 'Toneladas',
    REAL_TONS: 'Toneladas reales',
    TON: '{attribute} Ton',
    PERCENTAGE: 'Porcentaje',
    MANUAL: '¿La fecha de llegada es manual?',
    ENTRY_WEEKS: 'Fecha de llegada en Semanas',
    OC: 'OC',
    WAREHOUSE_LOCATIONS: 'Almacen y localidad',
    RECEPTION_COILS: 'Recepción y coils',
    COILS_SELECTION: 'Selección de Coils',
    SAVE_SELECTION: 'Guardar selección',
    SELECT_OC: 'Selecciona la orden de compra',
    TOTAL_PIECE: 'TOTAL NO. PIEZAS',
    PROJECTS: 'Proyectos',
    PROJECT_MANAGEMENT: 'Gestión de proyectos',
    CUTLIST: 'Cutlist',
    YES: 'Si',
    NO: 'No',
    BUSINESS: 'Comercial',
    VALIDATION_BUNDLE: 'El valor ingresado no es válido.',
  },
  filters: {
    TITLE: 'Filtros',
  },
  actions: {
    LOGOUT: 'Cerrar sesión',
    CANCEL: 'Cancelar',
    CANCELLED: 'Cancelado',
    CLOSE: 'Cerrar',
    ADD: 'Agregar',
    ACCEPT: 'Aceptar',
    SAVE: 'Guardar',
    EDIT: 'Editar',
    DELETE: 'Eliminar',
    EXPORT: 'Exportar',
    IMPORT: 'Importar',
    CHOOSE: 'Seleccionar',
    ACTIVATE: 'Activar',
    DETAIL: 'Detalle',
    ADDED: 'Guardado',
    UPDATED: 'Actualizado',
    DOWNLOADED: 'Descargado | Descargar',
    DELETED: 'Eliminado',
    SEE: 'Ver {attribute}',
    UPLOAD: 'Subir {attribute}',
    NEW: 'Nuevo {attribute}',
    APPROVE: 'Aprobar',
    'IN-TRANSIT': 'En tránsito',
    PRINT: 'Imprimir',
    ADD_ARTICLE: 'Agregar artículo',
    RECOVER: 'Recuperar',
    APPLIED: 'Aplicar',
    APPLY: 'Aplicar',
    ENTRY: 'Entrada',
    OUT: 'Salida',
    INACTIVE: 'Inactivar',
    SHOW_STATUS: 'Ver estatus',
    SEND: 'Enviar',
    RECEIVED: 'Recibido',
    RECEIVE: 'Recibir',
    ASSIGN: 'Asignar',
    VIEW_PROGRESS: 'Ver Progreso',
    CREATE_ORDER: 'Crear orden',
    CONFIRMATION: 'Confirmar',
    OC_PENDING: 'OC Pendiente',
    'PO-PENDING': 'OC Pendiente',
    IN_PRODUCTION: 'En producción',
    'IN-PRODUCTION': 'En producción',
    CREATE: 'Crear',
    FINISHED: 'Concluido',
    INVALIDATE: 'Invalidar',
  },
  settings: {
    TITLE: 'Configuración',
    THEME: 'Tema',
    THEME_MODE: { LIGHT: 'Claro', DARK: 'Obscuro' },
    LANG: 'Idioma',
  },
  locale: {
    ES: 'Español',
    EN: 'Ingles',
  },
  users: {
    MODEL: 'Usuario | Usuarios',
    PASSWORD: 'Contraseña',
    PASSWORD_CONFIRM: 'Confirmar contraseña',
  },
  scrap: {
    MODEL: 'Scrap | Scraps',
    USED: 'Utilizado',
    SCRAP_USED: 'Utilizar scrap',
    UPDATED: 'Fecha de Actualización',
  },
  suppliers: {
    MODEL: 'Proveedor | Proveedores',
  },
  customers: {
    MODEL: 'Cliente | Clientes',
  },
  'project-management': {
    MODEL: 'Gestión de proyecto | Gestión de proyectos',
    PROJECT_NATIONAL: 'Es proyecto nacional',
  },
  articles: {
    MODEL: 'Material | Materiales',
  },
  inventories: {
    MODEL: 'Consulta de existencia | Consulta de existencias',
  },
  history: {
    MODEL: 'Consulta de Kardex | Consulta de los Kardex',
    INITIAL_AMOUNT: 'Costo inicial',
    AMOUNT: 'Costo entrada',
    FINAL_AMOUNT: 'Costo salida',
    DEPARTURE_AMOUNT: 'Costo final',
  },
  categories: {
    MODEL: 'Categoría | Categorías',
  },
  locations: {
    MODEL: 'Localidad | Localidades',
  },
  types: {
    MODEL: 'Tipo | Tipos',
  },
  details: {
    MODEL: 'Detalle | Detalles',
  },
  payments: {
    MODEL: 'Pago | Pagos',
    PAYMENT_INVOICE: 'Pago a factura',
    PAYMENT_NUMBER: 'Número de pago',
    DATE: 'Fecha de pago',
    HISTORY: 'Historial | Historial de pagos',
  },
  'measurement-units': {
    MODEL: 'Unidad de medida | Unidades de medida',
  },
  warehouses: {
    MODEL: 'Almacén | Almacenes',
  },
  projects: {
    MODEL: 'Proyecto | Proyectos',
    DETAILS: 'Detalle de proyecto',
    ID: 'ID de proyecto',
    PROJECT_PRODUCTION: 'Producción de proyecto',
    DAILY_REPORT: 'Reportes de producción diaria',
    DIFFERENCE_PARTS: 'Diferencia Piezas',
    SCRAP_KG: 'Scrap Kg',
    PROGRESS: 'Progreso',
    PRODUCTION: 'Producción',
    ORDER: 'Orden de manufactura',
    MANUFACTURE: 'Manufactura',
    INVOICE: 'Factura',
    COILS: 'Coils | Coils utilizados',
  },
  mills: {
    MODEL: 'Molino | Molinos',
  },
  invoices: {
    MODEL: 'Factura | Facturas',
    INVOICE_NUMBER: 'Número de factura | No.factura',
    AMOUNT: 'Monto | Monto de factura',
    DATE: 'Fecha | Fecha de factura',
    TOTAL_AMOUNT: 'Monto total de venta',
    TOTAL_AMOUNT_BILLED: 'Monto total facturado',
    TOTAL_AMOUNT_INVOICED: 'Monto por facturar',
    TOTAL_AMOUNT_PAYMENT: 'Monto pagado',
    TOTAL_PERCENT_BILLED: 'Porcentaje total facturado',
    TOTAL_PERCENT_INVOICED: 'Porcentaje por facturar',
    TOTAL_PERCENT_PAYMENT: 'Porcentaje pagado',
    HAS_PAYMENTS: 'La factura cuenta con pagos',
    PENDING_INVOICE: 'Pendiente de facturar',
  },
  'purchase-orders': {
    MODEL: 'Orden de compra | Órdenes de compra',
  },
  coils: {
    MODEL: 'Coil | Coils',
    INVENTORY: 'Inventario de Coils',
  },
  'inventory-relocations': {
    MODEL: 'Reubicación de material | Reubicación de materiales',
  },
  'inventory-transfers': {
    MODEL: 'Traspaso de material | Traspasos de materiales',
    STATUS: 'Movimientos de estatus',
    DETAIL: 'detalle',
  },
  'movement-requests': {
    MODEL: 'Movimiento manual | Movimientos manuales',
  },
  'purchase-order-details': {
    MODEL: 'Detalle Orden de compra | Detalles Órdenes de compra',
    TEXT_MODAL:
      '¿Estás seguro de continuar, esta acción afectará en los totales?',
    TEXT_CONFIRM:
      '¿Estás seguro de continuar, esta acción no se podrá revertir, y las cantidades de los detalles no se podrán modificar?',
  },
  certificates: {
    MODEL: 'Certificado | Certificados',
    EXISTING: 'Certificados existentes',
  },
  'log-reports': {
    TITLE: 'Log de producción',
    MODEL: 'Reporte de producción | Reportes de producción',
    LOG: 'Log | Logs',
  },
  bundles: {
    MODEL: 'Bundle | Bundles',
  },
  receipts: {
    MODEL:
      'Consulta de recepción | Consulta de recepciones | Recepciones | Alta de almacen y localidad',
    MODEL_SECONDARY: 'Recepción de mercancia | Recepción de mercancias',
    CREATING: 'Estamos creando la recepción, espera un momento....',
    QUANTITY: 'Cantidad pedida',
    RECEIVED: 'Cantidad que ya se ha recibido',
    TO_BE_RECEIVED: 'Cantidad que se va a recibir',
    ADD_TITLE: ' Alta de almacen y localidad',
    TOTAL_RECEIVED: 'Total Recepcionado',
    QUANTITY_RECEIVED: 'Cantidad recibida',
  },
  columns: {
    INDICATOR: 'Indicador',
    USER: 'Usuario',
    PRODUCT: 'Producto',
    NAME: 'Nombre',
    PRICE: 'Precio',
    PRICE_TON: 'Precio Tonelada',
    STATUS: 'Estatus',
    CREATED_AT: 'Fecha de creación',
    SUPPLIER: 'Proveedor',
    DATE: 'Fecha',
    INIT_DATE: 'Fecha de colocación',
    ENTRY_DATE: 'Fecha de llegada',
    TOTAL: 'Total',
    CURRENCY: 'Moneda',
    MXN: 'MXN',
    USD: 'USD',
    ACTIONS: 'Acciones',
    FOLIO: 'Folio',
    LAST_NAME: 'Apellido',
    EMAIL: 'Correo',
    ROL: 'Rol',
    TITLE: 'Título',
    DESCRIPTION: 'Descripción',
    PART_NUMBER: 'No.Parte',
    CATEGORY: 'Categoria',
    TYPE: 'Tipo de movimiento',
    METRIC: 'U.M',
    ID: 'ID',
    ARTICLE_NAME: 'Nombre artículo',
    ARTICLE: 'Artículo',
    QUANTITY: 'Cantidad {attribute}',
    UNIT_PRICE: 'Precio Unitario',
    TAX: 'Impuesto',
    WAREHOUSE: 'Almacén',
    REASON: 'Motivo',
    PURCHASE_ORDER: 'Orden de compra | oc',
    RM: 'No.RM',
    TYPE_MOVEMENT: 'T.M',
    CERTIFICATE: 'Certificado | Nota de certificado',
    INITIAL_QUANTITY: 'C.I',
    AMOUNT: 'C | Cantidad',
    FINAL_QUANTITY: 'C.F',
    FOLIO_SUPPLIER_INVOICE: 'Folio de factura de proveedor',
    NO: 'No.',
    PEDIMENT: 'Pedimento',
    REMAINING: 'Restante',
    TO_BE_RECEIVED: 'Por recibir',
    RECEIVED: 'Recibido',
    TOTAL_RECEIVED: 'Total Recibido',
    RFC: 'RFC',
    CONDITIONS: 'Condiciones',
    INITIAL_QUANTITY_TEXT: 'Cantidad inicial',
    AMOUNT_TEXT: 'Cantidad',
    FINAL_QUANTITY_TEXT: 'Cantidad final',
    CERTIFICATE_FOLIO: 'Folio de Certificado',
    UNIT_COST: 'Costo Unitario',
    RELOCATION: 'Reubicación',
    TRANSFERS: 'Traspasos',
    HAS_CREDIT: '¿Tiene crédito?',
    CONTACT: 'Nombre de contacto',
    CREDIT_DAYS: 'Días de crédito',
    COUNTRY: 'País',
    PHONE: 'Teléfono',
    GAUGE: 'Calibre',
    GALVANIZED: 'Galvanizado',
    HARDNESS: 'Dureza',
    TOTAL_PAID: 'Total pagado',
    PAYABLE: 'Total por pagar',
    COLOR_TYPE: 'Tipo de pintura',
    COLOR: 'Color',
    COLOR_ABBREVIATION: 'Abreviatura de color',
    WIDTH: 'Ancho',
    MILL: 'Molino',
    PAYMENTS_TYPE: 'Tipo de pago',
    PAYMENTS_METHOD: 'Forma de pago',
    MILLS: 'Molinos',
    COIL_NUMBER: 'Numero de Coil | No. Coils',
    WEIGHT_NET: 'Weight NET wt (ton)',
    WEIGHT: 'Peso/Pie | Peso en lbs',
    FOOTAGE: 'Theo footage',
    COILS: 'Coil | Coils',
    LOCATION: 'Ubicación',
    CUSTOMER: 'Cliente',
    DEADLINE: 'Fecha de entrega',
    PROGRESS: 'Progreso',
    JOB_NUMBER: 'Job number',
    BUNDLE: 'Bundle | Bundle/Libra',
    BUNDLE_CODE: 'Bundle Code',
    BUNDLE_NUMBER: 'Bundle number',
    BUNDLE_PZ: 'Bundle Pz',
    BUNDLE_INCHES: 'Pulgadas del bundle',
    BUNDLE_FRACTION: 'Fracción del bundle',
    SCRAP_FEET: 'Total scrap feet',
    TOTAL_SCRAP_FEET: 'Total scrap feet',
    SECOND_LINE: 'Total Second line feet | Second Line',
    ESTIMATED_DAILY_PRODUCTION: 'Producción estimada diaria',
    TOTAL_LB: 'Total lbs',
    TOTAL_KG: 'Total Kg | Kg Total de Proyecto',
    PARTS: 'Piezas',
    FEET: 'Feet | Total feet decimal',
    INCHES: 'Inches | Inches decimales',
    INCHES_FRACTION: 'Pulgada y Fracción ',
    TOTAL_LF: 'Total L/F',
    SQUARES: 'NO. of squares | Squares',
    SQUARES_PRICE: 'Precio Sqr',
    METERS: 'Metros  |  M2',
    METERS_PRICE: 'Precio Metros | Precio M2',
    TONS: 'Toneladas',
    FT: 'Ft 2 totales',
    DAYS_PRODUCTION: 'Dias de producción',
    WEIGHT_PRE_SHEET: 'Weight per sheet',
    COMMENTS: 'Comentarios',
    SHEETS_BUNDLE: 'Sheets per bundle',
    SHEETS_BUNDLE_RED: 'Sheets per bundle red',
    QUANTITY_BUNDLES: 'Bundle quantity',
    EXACT_BUNDLE: 'Cantidad de bundle’s exacto',
    COMODIN: 'Bundle comodín | Peso comodín',
    WORK_WEIGHT: 'Peso obra',
    IS_IN_USE: 'En uso',
    COVER_WIDTH: 'Cover width',
    LENGTH: 'Length',
    TOTAL_PARTS: 'Piezas totales',
    TOTAL_SQF: 'Total Sqf',
    LINER_FT: 'Linear Feet',
    LINER_TON: 'Linear Tons',
    TOTAL_LINEAR_TONS: 'Total linear tons',
    SCRAP_KG: 'Scrap Kg',
    DAY: 'Día',
    WEIGHT_BALANCE: 'Disponible',
    COIL_STATUS: 'Estatus de Coil',
    KSI: 'KSI(YP)',
    MAIN_CONTACT: 'Contacto Principal',
    ZIP_CODE: 'Código Postal',
    CITY: 'Ciudad',
    STATE: 'Estado',
    ADDRESS: 'Dirección',
    DESTINATION: 'Destino',
    CULTIST: 'Cutlist',
    TOTAL_WEIGHT_POUNDS: 'Total weight pounds',
    PRODUCED_PARTS: 'Piezas producidas',
    PRODUCED_KG: 'Kg Producidos',
    POUNDS_PRODUCED: 'Libras producidas',
    TOTAL_BUNDLE_POUNDS: 'Libras totales del bundle',
    TONNES_PRODUCED: 'Toneladas Producidas',
    TOTAL_TONS_TO_BE_PRODUCED: 'Total Toneladas a producir',
    TOTAL_PARTS_PRODUCED: 'Total Piezas Producidas',
    TOTAL_PARTS_TO_BE_PRODUCED: 'Total Piezas a producir',
    TOTAL_PARTS_PENDING: 'Total Piezas pendientes',
    TOTAL_SCRAP: 'Total Scrap',
    LINER_KG: 'Liner KG',
    PAYMENT_PERCENTAGE: 'Porcentaje de pago',
    SCRAP_USED_DATE: 'Fecha de Actualización',
    SCRAP_USED: 'Utilizado',
    SCRAP: 'SCRAP',
  },
  status: {
    ACTIVED: 'Activo',
    DELETED: 'Eliminado',
    INACTIVED: 'Inactivo',
    REQUESTED: 'En proceso',
    PENDING: 'Pendiente',
    APPLIED: 'Aplicado',
    DONE: 'Completado',
    DRAFTED: 'Borrador',
    CANCELLED: 'Cancelado',
    IN_PROCESS: 'Proceso',
    RECEIVE: 'Recibir',
    RECEIVED: 'Recibida',
    APPROVE: 'Aprobado',
    APPROVED: 'Aprobado',
    IN_TRANSIT: 'En tránsito',
    SEND: 'Enviar',
    SENT: 'Enviado',
    QUOTING: 'Cotizando',
    OC_PENDING: 'OC Pendiente',
    'PO-PENDING': 'OC Pendiente',
    IN_PRODUCTION: 'En producción',
    WITH_PO: 'Con OC',
    FINISHED: 'Concluido',
    INVALIDATE: 'Invalidado',
  },
  validation: {
    ACCEPTED: 'El campo {attribute} debe ser aceptado.',
    ACTIVE_URL: 'El campo {attribute} no es una URL válida.',
    AFTER: 'El campo {attribute} debe ser una fecha después a {date}.',
    AFTER_OR_EQUAL:
      'El campo {attribute} debe ser una fecha posterior o igual a {date}.',
    ALPHA: 'El campo {attribute} solo puede contener letras.',
    ALPHA_DASH:
      'El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.',
    ALPHA_NUM: 'El campo {attribute} solo puede contener letras y números.',
    ARRAY: 'El campo {attribute} debe ser una matriz.',
    BEFORE: 'El campo {attribute} debe ser una fecha antes de {date}.',
    BEFORE_OR_EQUAL:
      'El campo {attribute} debe ser una fecha antes o igual a {date}.',
    BETWEEN: {
      NUMERIC: 'El {attribute} debe estar entre {min} y {max}.',
      FILE: 'El {attribute} debe estar entre {min} y {max} kilobytes.',
      STRING: 'El {attribute} debe estar entre {min} y {max} caracteres.',
      ARRAY: 'El {attribute} debe estar entre {min} y {max} artículos.',
    },
    BOOLEAN: 'El campo {attribute} debe ser verdadero o falso.',
    CONFIRMED: 'El {attribute} la confirmación no coincide.',
    DATE: 'La {attribute} no es una fecha valida.',
    DATE_FORMAT: 'La {attribute} no coincide con el formato {format}.',
    DIFFERENT: 'El {attribute} y {other} deben ser diferentes.',
    DIGITS: 'El {attribute} deben ser {digits} dígitos.',
    DIGITS_BETWEEN: 'El {attribute} debe estar entre {min} y {max} dígitos.',
    DIMENSIONS: 'El {attribute} tiene dimensiones de imagen inválidas.',
    DISTINCT: 'El {attribute} campo tiene un valor duplicado.',
    EMAIL:
      'El campo {attribute} debe ser una dirección de correo electrónico válida.',
    EXISTS: 'El seleccionado {attribute} no es válido.',
    FILE: 'El {attribute} debe ser un archivo.',
    FILLED: 'El {attribute} campo debe tener un valor.',
    GT: {
      NUMERIC: 'El {attribute} debe ser mayor que {value}.',
      FILE: 'El {attribute} debe ser mayor que {value} kilobytes.',
      STRING: 'El {attribute} debe ser mayor que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener más que {value} artículos.',
    },
    GTE: {
      NUMERIC: 'El {attribute} debe ser mayor o igual que {value}.',
      FILE: 'El {attribute} debe ser mayor o igual que {value} kilobytes.',
      STRING: 'El {attribute} debe ser mayor o igual que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener {value} artículos o más.',
    },
    IMAGE: 'La {attribute} debe ser una imagen.',
    IN: 'El seleccionado {attribute} no es válido.',
    IN_ARRAY: 'El {attribute} campo no existe en {other}.',
    INTEGER: 'El {attribute} debe ser un entero.',
    IP: 'La {attribute} debe ser una dirección IP válida.',
    IPV4: 'La {attribute} debe ser una dirección IPv4 válida.',
    IPV6: 'La {attribute} debe ser una dirección IPv6 válida.',
    JSON: 'La {attribute} debe ser una cadena JSON válida.',
    LT: {
      NUMERIC: 'El {attribute} debe ser menor que {value}.',
      FILE: 'El {attribute} debe ser menor que {value} kilobytes.',
      STRING: 'El {attribute} debe ser menor que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener menos que {value} artículos.',
    },
    LTE: {
      NUMERIC: 'El {attribute} debe ser menor o igual {value}.',
      FILE: 'El {attribute} debe ser menor o igual {value} kilobytes.',
      STRING: 'El {attribute} debe ser menor o igual {value} caracteres.',
      ARRAY: 'El {attribute} no debe tener más de {value} artículos.',
    },
    MAX: {
      NUMERIC: 'El {attribute} no puede ser mayor que {max}.',
      FILE: 'El {attribute} no puede ser mayor que {max} kilobytes.',
      STRING: 'El {attribute} no puede ser mayor que {max} caracteres.',
      ARRAY: 'El {attribute} no puede tener más de {max} artículos.',
    },
    MIMES: 'El {attribute} must be a file of type: {values}.',
    MIMETYPES: 'Los {attribute} must be a file of type: {values}.',
    MIN: {
      NUMERIC: 'El campo {attribute} debe ser al menos de {min}.',
      FILE: 'El campo {attribute} debe ser al menos de {min} kilobytes.',
      STRING: 'El campo {attribute} debe ser al menos de {min} caracteres.',
      ARRAY: 'El campo {attribute} debe tener al menos {min} artículos.',
    },
    NOT_IN: 'El seleccionado {attribute} no es válido.',
    NOT_REGEX: 'El {attribute} formato no es válido.',
    NUMERIC: 'El campo {attribute} tiene que ser un número.',
    PRESENT: 'El campo {attribute} debe estar presente.',
    REGEX: 'El campo {attribute} formato no es válido.',
    REQUIRED: 'El campo {attribute} es requerido.',
    REQUIRED_IF: 'El campo {attribute} es requerido cuando {other} es {value}.',
    REQUIRED_UNLESS:
      'El campo {attribute} es requerido a menos que {other} es en {values}.',
    REQUIRED_WITH:
      'El campo {attribute} es requerido cuando {values} esta presente.',
    REQUIRED_WITH_ALL:
      'El campo {attribute} es requerido cuando {values} esta presente.',
    REQUIRED_WITHOUT:
      'El campo {attribute} es requerido cuando {values} no esta presente.',
    REQUIRED_WITHOUT_ALL:
      'El campo {attribute} es requerido cuando ninguno de {values} estan presentes.',
    SAME: 'El campo {attribute} debe coincidir con {other}.',
    SIZE: {
      NUMERIC: 'El {attribute} debe ser {size}.',
      FILE: 'El {attribute} debe ser {size} kilobytes.',
      STRING: 'El {attribute} debe ser {size} caracteres.',
      ARRAY: 'El {attribute} debe contener {size} artículos.',
    },
    STRING: 'El {attribute} debe ser un texto.',
    TIMEZONE: 'El {attribute} debe ser una zona válida.',
    UNIQUE: 'El {attribute} ya se ha tomado.',
    UPLOADED: 'El {attribute} no se pudo cargar.',
    URL: 'El {attribute} formato no válido.',
    PASSWORD_EQUALS: 'Las contraseñas no coinciden.',
    VALIDATION_BUNDLE: 'El valor ingresado no es válido.',
    ATTRIBUTES: {},
  },
}
